import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
        <Link
          to="/"
          className="font-heading text-xl md:text-2xl font-bold text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          Hipobuy Sheet
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="#categories"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Categories
          </a>
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Complete Guide
          </Link>
          <div className="relative group">
            <button className="flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              Category Guides
              <i className="ri-arrow-down-s-line text-xs"></i>
            </button>
            <div className="absolute top-full right-0 mt-2 w-56 bg-background-50 border border-background-200/80 rounded-lg overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 shadow-sm z-30">
              <Link to="/shoes-spreadsheet-guide" className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                <i className="ri-footprint-line text-base w-5 h-5 flex items-center justify-center"></i>
                Shoes Guide
              </Link>
              <Link to="/hoodies-spreadsheet-guide" className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                <i className="ri-t-shirt-line text-base w-5 h-5 flex items-center justify-center"></i>
                Hoodies Guide
              </Link>
              <Link to="/tshirts-spreadsheet-guide" className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                <i className="ri-t-shirt-air-line text-base w-5 h-5 flex items-center justify-center"></i>
                T-Shirts Guide
              </Link>
              <Link to="/jackets-spreadsheet-guide" className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                <i className="ri-honour-line text-base w-5 h-5 flex items-center justify-center"></i>
                Jackets Guide
              </Link>
              <Link to="/accessories-spreadsheet-guide" className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                <i className="ri-glasses-line text-base w-5 h-5 flex items-center justify-center"></i>
                Accessories Guide
              </Link>
              <Link to="/bags-spreadsheet-guide" className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                <i className="ri-briefcase-line text-base w-5 h-5 flex items-center justify-center"></i>
                Bags Guide
              </Link>
            </div>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <button
          onClick={() => setMenuOpen(true)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          aria-label="Open menu"
        >
          <i className="ri-menu-line text-xl"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className="absolute inset-0 bg-black/30 backdrop-blur-sm"
            onClick={closeMenu}
          ></div>

          <div className="absolute top-0 right-0 w-[85%] max-w-sm h-full bg-background-50 flex flex-col animate-slide-in-right">
            <div className="flex items-center justify-between px-5 py-4 border-b border-background-200/70">
              <Link
                to="/"
                onClick={closeMenu}
                className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap cursor-pointer"
              >
                Hipobuy Sheet
              </Link>
              <button
                onClick={closeMenu}
                className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="Close menu"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-5 py-4">
              <div className="mb-6">
                <Link
                  to="/"
                  onClick={closeMenu}
                  className="flex items-center gap-3 py-3 text-foreground-800 font-medium cursor-pointer"
                >
                  <i className="ri-home-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  Home
                </Link>
                <Link
                  to="/hipobuy-spreadsheet-guide"
                  onClick={closeMenu}
                  className="flex items-center gap-3 py-3 text-foreground-800 font-medium cursor-pointer"
                >
                  <i className="ri-guide-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  Complete Guide
                </Link>
                <a
                  href="#categories"
                  onClick={closeMenu}
                  className="flex items-center gap-3 py-3 text-foreground-800 font-medium cursor-pointer"
                >
                  <i className="ri-grid-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  Categories
                </a>
              </div>

              <div className="border-t border-background-200/60 pt-5 mb-4">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
                  Category Guides
                </h4>
                <div className="space-y-1">
                  <Link to="/shoes-spreadsheet-guide" onClick={closeMenu} className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 flex-shrink-0">
                      <i className="ri-footprint-line"></i>
                    </div>
                    Shoes Guide
                  </Link>
                  <Link to="/hoodies-spreadsheet-guide" onClick={closeMenu} className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 flex-shrink-0">
                      <i className="ri-t-shirt-line"></i>
                    </div>
                    Hoodies Guide
                  </Link>
                  <Link to="/tshirts-spreadsheet-guide" onClick={closeMenu} className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 flex-shrink-0">
                      <i className="ri-t-shirt-air-line"></i>
                    </div>
                    T-Shirts Guide
                  </Link>
                  <Link to="/jackets-spreadsheet-guide" onClick={closeMenu} className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 flex-shrink-0">
                      <i className="ri-honour-line"></i>
                    </div>
                    Jackets Guide
                  </Link>
                  <Link to="/accessories-spreadsheet-guide" onClick={closeMenu} className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 flex-shrink-0">
                      <i className="ri-glasses-line"></i>
                    </div>
                    Accessories Guide
                  </Link>
                  <Link to="/bags-spreadsheet-guide" onClick={closeMenu} className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 flex-shrink-0">
                      <i className="ri-briefcase-line"></i>
                    </div>
                    Bags Guide
                  </Link>
                </div>
              </div>

              <div className="border-t border-background-200/60 pt-5">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
                  Shop Categories
                </h4>
                <div className="grid grid-cols-2 gap-1.5">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={closeMenu}
                      className="flex items-center gap-2 py-2.5 px-2 rounded-md text-xs text-foreground-600 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center flex-shrink-0`}></i>
                      <span className="truncate">{cat.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="px-5 py-4 border-t border-background-200/70">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={closeMenu}
                className="w-full flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line"></i>
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slide-in-right {
          animation: slideInRight 0.25s ease-out forwards;
        }
      `}</style>
    </nav>
  );
}